<template>
  <form class="">


      <div class="buildings-map-filters__banners">
        <template v-for="(banner, index) in banners">
          <a :href="banner.link" target="_blank" class="special-item mb-3" v-if="banner.link">
            <img :src="banner.image">
            <div class="special-item__content">
              <h5 class="special-item__title" v-if="banner.title">{{banner.title}}</h5>
              <span class="special-item__descr" v-if="banner.description">
                        {{banner.description}}
              </span>
            </div>
          </a>
          <section class="special-item mb-3 " v-else>
            <img :src="banner.image">
            <div class="special-item__content">
              <h5 class="special-item__title" v-if="banner.title">{{banner.title}}</h5>
              <span class="special-item__descr" v-if="banner.description">
                  {{banner.description}}
              </span>
            </div>
          </section>
        </template>
      </div>
        <div class="form-group">
            <input v-bind:disabled="filtersDisabled"  type="text" @input="isTyping = true"  v-model="form.name" class="form-control form-control--small" placeholder="Название ЖК" >
        </div>
        <!--<div class="form-group">
            <multiselect
                v-model="form.rooms"
                :options="rooms"
                placeholder="Кол-во комнат"
                :multiple="true"
                selectLabel=""
                :disabled = filtersDisabled
                selectedLabel="Выбрано"
                deselectLabel="Удалить"
            ></multiselect>
        </div>-->
        <div class="form-group">
            <multiselect v-model="roomValues"
                         :options="rooms"
                         placeholder="Кол-во комнат"
                         :disabled = filtersDisabled
                         :multiple="true"
                         track-by="value"
                         :close-on-select="false"
                         :searchable="false"
                         label="value"
                         selectLabel=""
                         deselectLabel=""
                         @select=onSelectRoom
                         @remove=onRemoveRoom
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                          Кол-во комнат
                        </span>
                </div>
              </template>
              <template slot="option" slot-scope="props" >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
              </template>
              <template slot="tag">{{''}}</template>
              <template slot="clear">
                <section class="multiselect__single-alert"  @click.prevent="clearSelect('room')" v-if="roomValues.length > 0">
                     <span class="multiselect__single-text">
                      {{num_word(roomValues.length, words_1)}} {{roomValues.length}} {{num_word(roomValues.length, words)}}
                </span>
                  <div class="multiselect__single-close-wrap">
                    <svg viewBox="0 0 10 10" class="multiselect__single-close" >
                      <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                    </svg>
                  </div>
                </section>
              </template>
              <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
              <span slot="noResult" class="multiselect__helper">Не найдено</span>

            </multiselect>
        </div>
    <div class="form-group">
      <multiselect v-model="floorValues"
                   :options="floors"
                   placeholder="Этажность"
                   :disabled = filtersDisabled
                   :multiple="true"
                   track-by="value"
                   :close-on-select="false"
                   :searchable="false"
                   label="value"
                   selectLabel=""
                   deselectLabel=""
                   @select=onSelectFloor
                   @remove=onRemoveFloor
      >
        <template slot="selection" slot-scope="{ values, search, isOpen }">
          <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                         Этажность
                        </span>
          </div>
        </template>
        <template slot="option" slot-scope="props" >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
        </template>
        <template slot="tag">{{''}}</template>
        <template slot="clear">
          <section class="multiselect__single-alert"  @click.prevent="clearSelect('floor')" v-if="floorValues.length > 0">
                     <span class="multiselect__single-text">
                      {{num_word(floorValues.length, words_1)}} {{floorValues.length}} {{num_word(floorValues.length, words)}}
                </span>
            <div class="multiselect__single-close-wrap">
              <svg viewBox="0 0 10 10" class="multiselect__single-close" >
                <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
              </svg>
            </div>
          </section>
        </template>
        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
        <span slot="noResult" class="multiselect__helper">Не найдено</span>

      </multiselect>
    </div>
        <div class="form-group">
            <multiselect
                v-model="districtValues"
                :options="districts"
                track-by="value"
                label="value"
                :disabled = filtersDisabled
                placeholder="Район"
                selectLabel=""
                :close-on-select="false"
                :searchable="false"
                deselectLabel=""
                :multiple="true"
                @select=onSelectDistrict
                @remove=onRemoveDistrict
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                          Район
                        </span>
                </div>
              </template>
              <template slot="option" slot-scope="props" >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
              </template>
              <template slot="tag">{{''}}</template>
              <template slot="clear">
                <section class="multiselect__single-alert"  @click.prevent="clearSelect('district')" v-if="districtValues.length > 0">
                     <span class="multiselect__single-text">
                      {{num_word(districtValues.length, words_1)}} {{districtValues.length}} {{num_word(districtValues.length, words)}}
                </span>
                  <div class="multiselect__single-close-wrap">
                    <svg viewBox="0 0 10 10" class="multiselect__single-close" >
                      <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                    </svg>
                  </div>
                </section>
              </template>
              <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
              <span slot="noResult" class="multiselect__helper">Не найдено</span>
            </multiselect>
        </div>

       <!-- <div class="form-group d-flex align-items-center">
            <div>
                <input  v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.square_from" class="buildings-map-filters__input form-control" placeholder="Площадь от (м2)">
            </div>
            <span class="mr-1 ml-1">—</span>
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.square_to" class="buildings-map-filters__input form-control" placeholder="до (м2)">
            </div>
        </div>
        <div class="form-group d-flex align-items-center" style="max-width: 100%">
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.apartment_price_from" class="buildings-map-filters__input form-control" placeholder="Цена от (руб.)" >
            </div>

            <span class="mr-1 ml-1">—</span>
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.apartment_price_to" class="buildings-map-filters__input form-control" placeholder="до (руб.)">
            </div>

        </div>-->

        <button class="btn button-link buildings-map-filters__btn-link" @click.prevent="clearFilter"  v-if="filtered" v-bind:disabled="filtersDisabled">
          <svg viewBox="0 0 10 10">
            <use xlink:href="/assets/site/images/sprites.svg?ver=44#sprite-close"></use>
          </svg>
            <span class="button-link__text ">Сбросить все фильтры</span>
        </button>

    </form>


</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        components:{
            Multiselect,
        },
        props:['options','filtersDisabled'],
        computed: {
            searchQuery() {
                return this.form.name;
            }
        },
        data() {
            return {
              filtered:false,
                statuses: [],
                isTyping: false,
              start:false,

              districtValues:[],
                form: {
                    name:'',
                    statuses:[],
                    rooms:[],
                    floors:[],
                    districts:[],
                    square_from:'',
                    square_to:"",
                    cottage_price_from:'',
                    cottage_price_to:'',
                },
              words:['элемент', 'элемента', 'элементов'],
              words_1:['Выбран', 'Выбрано', 'Выбрано'],
                districts: [],

                status_list: [

                    {
                        value:'part_passed',
                        label:'Частично сдан',
                        color:'#1E92E6'
                    },
                    {
                        value:'progress',
                        label:'Ведется строительство',
                        color:'#FDC20B'
                    },
                    {
                        value:'passed',
                        label:'ЖК сдан',
                        color:'#12B347'
                    },

                    {
                        value:'problem',
                        label:'Проблемный объект',
                        color:'#E61E44'
                    },
                ],
              floorValues:[],
              roomValues:[],
              rooms: ['1','2','3','4','5+'],
              floors: ['1','2','3', '4', '5'],

                banners: [],
            }
        },
        methods: {
          clearSelect(type) {
            if(type === 'district') {
              this.districtValues =[];
              this.districts.forEach(function (item){
                item.checked = false;
              })
            }

            if(type === 'room') {
              this.roomValues =[];
              this.rooms.forEach(function (item){
                item.checked = false;
              })
              this.form.rooms = this.roomValues.map(function (item){
                return item.value;
              });
            }
            if(type === 'floor') {
              this.floorValues =[];
              this.floors.forEach(function (item){
                item.checked = false;
              })
              this.form.floors = this.floorValues.map(function (item){
                return item.value;
              });
            }
          },
          num_word(value, words){
            value = Math.abs(value) % 100;
            var num = value % 10;
            if(value > 10 && value < 20) return words[2];
            if(num > 1 && num < 5) return words[1];
            if(num == 1) return words[0];
            return words[2];
          },
          onSelectDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
            this.districts[index].checked = true;

          },

          onRemoveDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
            this.districts[index].checked = false;

          },
          onSelectFloor (option) {
            let index = this.floors.findIndex(item => item.value== option.value);
            this.floors[index].checked = !this.floors[index].checked;

          },

          onRemoveFloor (option) {
            let index = this.floors.findIndex(item => item.value===option.value);
            this.floors[index].checked = false;
            if(this.start) {
              console.log(option);
              let index2 = this.floorValues.findIndex(item => item.value=== option.value);
              console.log(index2)
              if(index2 != -1){
                this.floorValues.splice(index2,1);
                console.log("remove");
              }
            }

          },
          onSelectRoom (option) {
            let index = this.rooms.findIndex(item => item.value== option.value);
            this.rooms[index].checked = !this.rooms[index].checked;


          },

          onRemoveRoom (option) {
            let index = this.rooms.findIndex(item => item.value==option.value);
            this.rooms[index].checked = false;
            if(this.start) {
              let index2 = this.roomValues.findIndex(item => item.value== option.value);
              if(index2 != -1){
                this.roomValues.splice(index2,1);
              }
            }

          },
            getBanner() {
                axios.get('/api/banner', {params:{position:'map-page-banner'}})
                    .then((response) => {
                        this.banners = response.data;
                    })
                    .catch((error) => {

                    })
            },
            AddStatus(selectedOption){
              let index = this.status_list.findIndex(item => item.value==selectedOption.value);
              this.status_list[index].checked = !this.status_list[index].checked;
                this.form.statuses.push(selectedOption.value);
            },

            RemoveStatus(selectedOption){
                let index = this.form.statuses.indexOf(selectedOption.value);
              let index2 = this.status_list.findIndex(item => item.value==selectedOption.value);
              this.status_list[index2].checked = false;
                if(index >= 0) {
                    this.form.statuses.splice(index,1);
                }
                console.log(this.form.statuses)
            },
            filterSubmit() {

                this.$emit('filterSubmit',{form:this.form,state:this.filtered});

            },
            clearFilter() {
                this.statuses = [];
                this.yearValues = [];
                this.districtValues = [];
              this.districts.forEach(function (item){
                item.checked = false;
              });
              this.years.forEach(function (item){
                item.checked = false;
              });
              this.status_list.forEach(function (item){
                item.checked = false;
              })
                for (var key in this.form) {
                    if(Array.isArray(this.form[key])) {
                        this.form[key] = [];
                    } else {
                        this.form[key] = '';
                    }

                }
                this.filtered = false;
                this.$emit('clearFilter');
            },
          areaFilter() {
              this.filtered = true;
          },
          getDistricts() {
            axios.get('/api/districts', {params: {type:'cottage'}})
            .then((response) => {
              let districts = response.data;
              this.districts = districts.map(function (item){
                return {value:item, checked:false}
              });

            })
                .finally(() => {
                  if(this.form.districts.length > 0) {
                    let vm = this;
                    this.form.districts.forEach(function(item, i, arr) {

                      vm.districtValues[i] = {
                        value:item,
                        checked:true
                      }
                      vm.onSelectDistrict(vm.districtValues[i]);
                    });
                  }
                })
          }
        },
        created:function() {
            //this.debouncedFilterSubmit = _.debounce(this.filterSubmit, 500);
        },
        watch: {
          districtValues: {
            deep: true,
            handler () {
              this.form.districts = this.districtValues.map(function (item){
                return item.value;
              })
            }
          },
          statuses: {
            deep: true,
            handler () {
              this.form.statuses = this.statuses.map(function (item){
                return item.value;
              })
            }
          },
          floorValues: {
            deep: true,
            handler () {
              this.form.floors = this.floorValues.map(function (item){
                return item.value;
              })
            }
          },
          roomValues: {
            deep: true,
            handler () {
              this.form.rooms = this.roomValues.map(function (item){
                return item.value;
              })
            }
          },
           form: {
               deep: true,
                   handler () {
                   var status = false;
                       for (var key in this.form) {
                           if(this.form[key]) {
                               if(Array.isArray(this.form[key])) {
                                   if(this.form[key].length > 0) {
                                       status =true;
                                   }
                               } else  {
                                   status =true;
                               }
                           }
                       }
                       if(status) {
                               this.filtered = true;
                           if(!this.isTyping){
                               this.filterSubmit()
                           }

                       } else  {
                           this.filtered = false;
                           if(!this.isTyping){
                               this.filterSubmit()
                           }
                       }

               }
            },
            searchQuery:_ .debounce(function() {
         this.isTyping = false;
    }, 800),
            isTyping: function(value) {
                if (!value) {
                    this.filterSubmit()
                }
            }
        },
        async mounted() {
          const districtsAwait =  await this.getDistricts();
          this.rooms = this.rooms.map(function (item){
            return {value:item, checked:false}
          });
          this.floors = this.floors.map(function (item){
            return {value:item, checked:false}
          });
            for (var key in this.form) {
                if(this.options[key]) {
                    this.form[key] = this.options[key]
                }
            }
          if(Object.keys(this.options).length === 0) {
            this.start = true;
          }
          if(Object.keys(this.options).length > 0) {
            let vm = this;
            if(this.form.floors.length > 0) {
              this.form.floors.forEach(function (item, i, arr) {

                vm.floorValues[i] = {
                  value: item,
                  checked: true
                }

                vm.onSelectFloor(vm.floorValues[i]);
              });
            }
              if(this.form.rooms.length > 0) {
                this.form.rooms.forEach(function(item, i, arr) {

                  vm.roomValues[i] = {
                    value:item,
                    checked:true
                  }

                  vm.onSelectRoom(vm.roomValues[i]);
                });
              if(this.form.districts.length > 0) {
                this.form.districts.forEach(function(item, i, arr) {

                  vm.districtValues[i] = {
                    value:item,
                    checked:true
                  }
                  vm.onSelectDistrict(vm.districtValues[i]);
                });
              }
            }
          }



          this.status_list = this.status_list.map(function (item){
            return {
              value:item.value,
              label:item.label,
              color:item.color,
              checked:false
            }
          });
            this.getBanner();
          setTimeout(() => {
            this.start = true;
          }, 0);
        }
    }

</script>
